// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"12":"8949be19","23":"cfe67d1e","87":"9d52eb38","121":"9945d81a","163":"16460d5c","251":"1a4ffae7","256":"25a4a499","460":"e92cc32f","606":"dca3edc8","693":"b2b1ecef","767":"d994f07c"}[chunkId] + ".chunk.js";
};